<template>
	<div @scroll="scroll" class="health">
		<div class="container">
			<ul class="list bg-fff">
				<li v-for="item in list" :key="item.id" class="qjc-clearfix">
					<span @click="$router.push('/dayu/health/detail/'+item.id)" class="am-block qjc-wid-100 qjc-fl">
						<img class="study-img qjc-fl" :src="item.pic">
						<dl class="qjc-fl">
							<dt>{{ item.title }}</dt>
							<dd class="label">
								<span class="qjc-fts-24">{{ item.source }}</span>
							</dd>
							<dd class="label">
								<span class="qjc-fts-24">{{ item.created_at }}</span>
							</dd>
						</dl>
					</span>
				</li>
			</ul>
		
		</div>
		
		<div v-if="isLoding" class="loading qjc-fixed qjc-texta-c">
			<img src="../../../assets/images/dayu_loding.png" alt="加载中">
			<p>正在努力加载...</p>
		</div>
		
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Toast } from 'vant'
	
	Vue.use(Toast);
	
	import { getHealthDy, studyList } from "@/utils/axios"
	
	export default{
		name: 'dayuHealth',
		data() {
			return {
				list: [],
				
				page: 1,
				pages: 0,
				size: 4,
				
				isLoding: true
				
			}
		},
		created() {
			this.$nextTick(() => {
				this.getList();
			})
		},
		methods: {
			// 滚动最底部加载
			scroll(e) {
				var target = e.target;
				if(this.page < this.pages){
					// 5误差
					if((target.clientHeight + target.scrollTop) >= (target.scrollHeight - 5)){
						this.isLoding = true;
						this.page += 1;
						this.getList();
					}
				}
			},
			
			//获取列表
			getList() {
				var that = this;
				studyList({page: this.page, pagesize: this.size}).then(function(res){
					console.log(res);
					if(res.code == 200){
						that.list = that.list.concat(res.data.data);
						
						// 分页信息
						that.page = Number(res.data.pager.page);
						that.pages = res.data.pager.pagecount;
						
					}else{
						Toast.fail(res.errmsg);
					}
					
					that.isLoding = false;
				});
			}
			
		}
	}
</script>

<style scoped>
	.health{
		height: 9.9rem;
		background: url(https://meidn-image.oss-cn-beijing.aliyuncs.com/file/2020/home_bg.png) no-repeat;
		background-size: 100% 100%;
		overflow: auto;
	}
	.list{
		margin: 0 0.8rem;
		padding-top: 0.09rem;
	}
	.list>li{
		padding: 0.4rem 0;
		cursor: pointer;
		border-bottom: 0.01rem solid #386CA0;
		transition: all .3s;
	}
	.list>li:hover{
		transform: scale(1.01);
	}
	.list>li>span{
		display: block;
		color: #E1E7F5;
		font-weight: 400;
	}
	.list .study-img{
		width: 2.1rem;
		height: 1.8375rem;
		margin-right: 0.24rem;
	}
	.list dl{
		max-width: 14.4rem;
	}
	.list dt{
		font-weight: 400;
		font-size: 0.4rem;
		line-height: 0.56rem;
	}
	.list dd{
		font-size: 0.24rem;
		line-height: 0.24rem;
		margin-top: 0.36rem;
	}
	.list .label{
		margin-top: 0.32rem;
		color: #8D9199;
	}
	.list .label .check-eye{
		display: inline-block;
		width: 0.3rem;
		height: 0.24rem;
		margin-right: 0.1rem;
		vertical-align: middle;
	}
	.list .label .create-time{
		display: inline-block;
		width: 0.12rem;
		height: 0.12rem;
		vertical-align: middle;
	}
	.list .label span{
		margin-right: 0.64rem;
		vertical-align: middle;
	}
	
	.loading{
		top: 50%;
		left: 50%;
		font-size: 0.24rem;
		line-height: 0.24rem;
		color: #5FD6FF;
		transform: translate(-50%, -50%);
		z-index: 999;
	
	}
	.loading img{
		width: 0.96rem;
		height: 0.96rem;
		animation: spin 1.5s linear infinite;
	}
	@keyframes spin{
		from{
			transform: rotateZ(0deg);
		}
		to{
			transform: rotateZ(360deg);
		}
	}
	
</style>
